import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import logo from '@/assets/logo.png';

export function PrivacyPolicy(): React.JSX.Element {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white">
            {/* Navigation */}
            <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b border-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-24">
                        <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
                            <img src={logo} alt="List8.app Logo" className="h-20 w-auto" />
                        </div>
                        <div className="flex items-center space-x-4">
                            <Button variant="ghost" onClick={() => navigate('/login')}>
                                Log in
                            </Button>
                            <Button onClick={() => navigate('/signup')}>
                                Start Today
                            </Button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto">
                <h1 className="text-4xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
                <p className="text-gray-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>

                <div className="prose prose-lg text-gray-600 space-y-8">
                    <p>
                        Hey there! We value your privacy just as much as we value our own. Here's the lowdown on how we handle your data at List8.app.
                    </p>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">1. What We Collect</h2>
                        <p>
                            We collect the basics: your name, email, and the photos you upload. We need these to create your account and process your images. We don't sell your personal data to third parties. Period.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How We Use Your Data</h2>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>To provide our services (obviously!)</li>
                            <li>To improve our AI models (so your photos look even better next time)</li>
                            <li>To send you important updates (no spam, we promise)</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Your Photos</h2>
                        <p>
                            The photos you upload are yours. We process them to give you the results you paid for. We might use them internally to train our AI, but we won't share them publicly without your permission.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Cookies</h2>
                        <p>
                            We use cookies to keep you logged in and to see how people use our site. It helps us make List8.app better for everyone.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Questions?</h2>
                        <p>
                            If you have any concerns about your privacy, email us at <a href="mailto:admin@list8.app" className="text-blue-600 hover:underline">admin@list8.app</a>.
                        </p>
                    </section>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-gray-900 text-white py-12 mt-auto">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p className="text-gray-400">
                        &copy; {new Date().getFullYear()} List8.app. All rights reserved.
                    </p>
                </div>
            </footer>
        </div>
    );
}
